/**
 * Mobile Nav
 */

// Vendors
import $ from 'jquery';

// Toggle mobile nav
$('[data-nav-mobile-toggle]').on('click', (event) => {
  event.preventDefault();

  if ($('body').hasClass('nav-mobile-is-visible')) {
    $('.hamburger').removeClass('hamburger--active');
    $('html, body').removeClass('nav-mobile-is-visible');
    $('.nav-mobile, .nav-mobile-multicolumn').removeClass(
      'nav-mobile--visible'
    );

    setTimeout(() => {
      $('.nav-mobile').scrollTop(0).hide();
      $('.nav-mobile').removeClass('nav-mobile__submenu-is-visible');
      $('.nav-mobile li').removeClass('nav-mobile__item--submenu-is-visible');
    }, 300);
  } else {
    $('.hamburger').addClass('hamburger--active');
    $('html, body').addClass('nav-mobile-is-visible');
    $('.nav-mobile, .nav-mobile-multicolumn')
      .css({ display: 'block' })
      .delay(300)
      .addClass('nav-mobile--visible');
  }
});

$('[data-nav-mobile-hide]').on('click', (event) => {
  $('.hamburger').removeClass('hamburger--active');
  $('html, body').removeClass('nav-mobile-is-visible');
  $('.nav-mobile').removeClass('nav-mobile--visible');

  setTimeout(() => {
    $('.nav-mobile').scrollTop(0);
    $('.nav-mobile').removeClass('nav-mobile__submenu-is-visible');
    $('.nav-mobile li').removeClass('nav-mobile__item--submenu-is-visible');
  }, 300);
});

$('.nav-mobile__item--has-submenu').on('click', (event) => {
  const $toggleIcon = $(event.target).children('span');
  const $nestedMenu = $(event.target).siblings('.nav-mobile__nested-menu');

  // Check if already opened
  if (!$nestedMenu.hasClass('nav-mobile__nested-menu--open')) {
    $nestedMenu.addClass('nav-mobile__nested-menu--open');
    $nestedMenu.css('height', 'auto');
    $toggleIcon.css('transform', 'rotate(0deg)');
  } else {
    $nestedMenu.removeClass('nav-mobile__nested-menu--open');
    $nestedMenu.css('height', '1px');
    $toggleIcon.css('transform', 'rotate(-90deg)');
  }
});

// Toggle submenu open and close when you click on the li
$(document).on(
  'click',
  '.nav-mobile-multicolumn .menu-item.has-submenu',
  (event) => {
    const $toggleIcon = $(event.currentTarget).find('.perc-icon-chevron-right');
    const $nestedMenu = $(event.currentTarget).find('.nested-menu');
    const $title = $(event.currentTarget).find('.submenu-title');
    const $mobileMenu = $(event.currentTarget)
      .parentsUntil('.nav-mobile-multicolumn')
      .parent();
    const $menuItems = $mobileMenu.find('li.menu-item').filter(function (i) {
      return this != event.currentTarget;
    });

    // Check if already opened
    if (!$nestedMenu.hasClass('open')) {
      $nestedMenu.addClass('open');
      $nestedMenu.css('height', 'auto');
      $title.addClass('open');
      $toggleIcon.css('transform', 'rotate(90deg)');
      $menuItems.addClass('hide');
    } else {
      $nestedMenu.removeClass('open');
      $nestedMenu.css('height', '1px');
      $title.removeClass('open');
      $toggleIcon.css('transform', 'rotate(0deg)');
      $menuItems.removeClass('hide');
    }
  }
);

// Toggle submenu open and close when you click on the caret
$('.nav-mobile__submenu-toggle-icon').on('click', (event) => {
  const $toggleIcon = $(event.target);
  const $nestedMenu = $(event.target)
    .parent()
    .siblings('.nav-mobile__nested-menu');

  // Check if already opened
  if (!$nestedMenu.hasClass('nav-mobile__nested-menu--open')) {
    $nestedMenu.addClass('nav-mobile__nested-menu--open');
    $nestedMenu.css('height', 'auto');
    $toggleIcon.css('transform', 'rotate(0deg)');
  } else {
    $nestedMenu.removeClass('nav-mobile__nested-menu--open');
    $nestedMenu.css('height', '1px');
    $toggleIcon.css('transform', 'rotate(-90deg)');
  }
});
